function runGetReferrerSearchEngineLegible(_) {
	return {
		"google.com": "google",
		"bing.com": "bing",
		"yahoo.com": "yahoo",
		"baidu.com": "Baidu",
		"duckduckgo.com": "DuckDuckGo",
		"yandex.com": "Yandex",
		"ask.com": "Ask",
		"naver.com": "Naver",
		"aol.com": "AOL",
		"seznam.cz": "Seznam",
		"yippy.com": "Yippy",
		"a9.com": "Amazon A9",
		"openverse.com": "OpenVerse (CC Search)",
		"gibiru.com": "Gibiru",
		"searchencrypt.com": "Search Encrypt",
		"searx.me": "Searx",
		"startpage.com": "StartPage",
		"swisscows.com": "Swisscows",
		"ecosia.org": "Ecosia",
		"gigablast.com": "Gigablast",
		"lycos.com": "Lycos",
		"mojeek.com": "Mojeek",
		"neeva.com": "Neeva",
		"qmamu.com": "Qmamu",
		"wolframalpha.com": "WolframAlpha",
		"webcrawler.com": "WebCrawler",
		"metager.org": "MetaGer",
		"qwant.com": "Qwant",
		"you.com": "You",
		"oscobo.co.uk": "Oscobo",
		"infinitysearch.co": "Infinity Search",
		"yep.com": "YEP",
		"anoox.com": "Anoox",
	}[_.replace(new URL(document.referrer).hostname || '', 'www.', '')];
}